import { Geotab } from "@fairfleet/geotab";
import { TripRef } from "./TripRef";

/**
 * Sets the driver for a given trip.
 *
 * @param trip - The trip to set the driver for.
 * @param driverId - The id of the driver to set the trip to.
 * @returns The id of the driver change.
 */
export function setDriverForTrip(trip: Pick<TripRef, "device" | "start">, driverId: string, geotabClient: Geotab) {
  return geotabClient.add("DriverChange", {
    type: "TripDriver",
    device: { id: trip.device.id },
    driver: { id: driverId },
    dateTime: trip.start,
  });
}
